import React, { useEffect } from 'react';

import { mergeWith } from 'lodash-es';
import { useLocation } from 'react-router-dom';

import AdobeAnalyticsAdapter from 'state/adobe/adobe-analytics-adapter';
import analyticsProvider from 'state/analytics';
import { IAnalyticsAdapter } from 'state/analytics/types';
import SessionStorage, { SessionStorageKeys } from 'utils/session-storage';
import { IUtmData } from 'utils/session-storage/types';

const SHOULD_DUPLICATE_EVENTS_TO_GTM_DATA_LAYER = true;

const AnalyticsWrapper: React.FC = ({ children }) => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const analyticsAdapters: IAnalyticsAdapter[] = [
    new AdobeAnalyticsAdapter(SHOULD_DUPLICATE_EVENTS_TO_GTM_DATA_LAYER),
  ];

  useEffect(() => {
    analyticsProvider.initialize(analyticsAdapters);
  }, [analyticsAdapters]);

  useEffect(() => {
    const initialUtmData = SessionStorage.getItem(SessionStorageKeys.UTM_DATA);
    const updatedUtmData: IUtmData = {
      utm_source: searchParams.get('utm_source'),
      utm_medium: searchParams.get('utm_medium'),
      utm_campaign: searchParams.get('utm_campaign'),
      utm_term: searchParams.get('utm_term'),
      utm_content: searchParams.get('utm_content'),
    };

    const utmData: IUtmData = mergeWith({}, initialUtmData, updatedUtmData, (a, b) =>
      b === null ? a : undefined
    );
    SessionStorage.setItem(SessionStorageKeys.UTM_DATA, utmData);
  }, [searchParams]);

  return <>{children}</>;
};

export default AnalyticsWrapper;
